
export default {
  name: 'MegasredaRecomendedSocialInArticle',
  computed: {
    channels() {
      const channels = this.$store.getters['settings/getSocialChannels']
      return channels.filter((channel) => channel.isShow)
    },
  },
}
